import { useMemo, useState } from "react";

import { AddMedicationModal } from "components/AddMedicationModal";
import { AddPrescriptionModal } from "components/AddPrescriptionModal/AddPrescriptionModal";
import { useDataTableSelection } from "components/ui/DataTable/hooks/useDataTableSelection";
import { usePaginatedLongTermMedications } from "features/medications/hooks/usePaginatedLongTermMedications";

import { DrugsTable } from "../DrugsTable/DrugsTable";
import s from "./LongTermMedication.module.css";

const LongTermMedication = ({ patientId, deleteDrug }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState("All");
  const selection = useDataTableSelection();

  const { data, isLoading, isError, refetch } =
    usePaginatedLongTermMedications(
      patientId,
      currentPage,
      searchQuery,
      rows === "All" ? 9999 : rows
    );

  const medications = useMemo(() => [...(data?.data || [])], [data]);
  const totalRecords = useMemo(() => data?.totalRecords ?? 0, [data]);

  const selectedMedications = useMemo(
    () => medications.filter((med) => selection.isSelected(med.id)),
    [medications, selection]
  );

  return (
    <div className={s.longTermWrapper}>
      <div className={s.topWrapper}>
        <h3 className={s.title}>Long term medications</h3>
        <div className={s.buttonGroup}>
          <AddMedicationModal usageType="LONGTERM" />
          {selection.selectedCount > 0 && (
            <AddPrescriptionModal
              initialMedications={selectedMedications}
              isRenewal={true}
            />
          )}
        </div>
      </div>
      <DrugsTable
        items={medications}
        isLoading={isLoading}
        isError={isError}
        errorLabel="this patient's long term medications"
        onRetry={refetch}
        emptyTitle="No Long term prescriptions"
        selection={selection}
        deleteDrug={deleteDrug}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        totalRecords={totalRecords}
        rows={rows}
        setRows={setRows}
      />
    </div>
  );
};

export { LongTermMedication };
